import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, LoaderService } from '~services';

@Component({
  selector: 'app-login-view',
  template: ``,
})
export class LoginViewComponent implements OnInit, OnDestroy {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private loaderService: LoaderService,
  ) {}

  async ngOnDestroy(): Promise<void> {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    this.authService.redirectToLogin(this.returnTo);
  }

  private get returnTo() {
    return this.activatedRoute.snapshot.queryParams.returnTo;
  }
}
